<template>
  <div class="page-wrap" >
    <!-- 顶部导航栏 -->
    <LayoutHead ref="layoutHead" @handleSearch="handleSearch"/>
    <!-- 导航栏 -->
    <!-- 具体内容 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="homeView"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="homeView"/>
    <LayoutFoot/>
  </div>
</template>

<script>
import LayoutHead from "@/layout/layout-head.vue";
import LayoutFoot from "@/layout/layout-foot.vue";

export default {
  name: 'LayoutPage',
  components: {
    LayoutHead,
    LayoutFoot
  },
  data() {
    return {}
  },
  methods: {
    handleRoute(url) {
      this.$refs.layoutHead.handleClickRouter({name: url});
    },
    clickScrollTo() {
      const name = this.$route.name;
      if (name === 'homeView') {
        this.$refs.homeView.scrollToTop();
      }
    },
    handleSearch(keywords) {
      if (this.$refs.homeView) {
        this.$refs.homeView.handleSearch(keywords);
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
